module.exports = __webpack_public_path__ + "img/settings.ec66e91d.svg";